import { render } from "./WrenchIcon.vue?vue&type=template&id=98472d46"
import script from "./WrenchIcon.vue?vue&type=script&lang=js"
export * from "./WrenchIcon.vue?vue&type=script&lang=js"

import exportComponent from "/Users/joecortinhas/Documents/code/DigitalLaborSolutions/dlstracker_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__